// 2026-10-14 — "Broadcast" hands a match to Zenminds Live (the live-broadcast graphics app).
// Only the broadcaster account sees it: that account creates and codes the broadcast
// matches here, and Zenminds Live follows the coding live. Pressing it opens Zenminds Live
// on that match (creating it there the first time); nothing is written to ZCD.
import { Radio } from "lucide-react";
import useAuthStore from "../../store/auth.store";

export const BROADCAST_EMAIL = "broadcaster@zencricketdata.com";
export const BROADCAST_URL = (import.meta.env.VITE_BROADCAST_URL || "http://52.206.7.169").replace(/\/$/, "");

export function isBroadcaster(user) {
  return (user?.email || "").trim().toLowerCase() === BROADCAST_EMAIL;
}

export function broadcastHref(matchId) {
  return `${BROADCAST_URL}/broadcast?zcd_match=${encodeURIComponent(matchId)}`;
}

/** variant: "row" (match list), "chip" (mobile list), "menu" (coding-screen menu) */
export default function BroadcastButton({ matchId, variant = "row", onClick }) {
  const user = useAuthStore((s) => s.user);
  if (!matchId || !isBroadcaster(user)) return null;
  const cls = {
    row: "flex gap-1.5 bg-rose-600 hover:brightness-110 px-3 py-1 items-center rounded text-xs font-semibold text-white transition-all",
    chip: "shrink-0 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider px-3 py-1.5 rounded-md bg-rose-600 text-white font-semibold",
    menu: "flex items-center gap-2 h-9 px-2 rounded text-xs uppercase tracking-wider hover:bg-bg-secondary/60 text-rose-400 hover:text-rose-300",
  }[variant];
  return (
    <a
      href={broadcastHref(matchId)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={cls}
      title="Open this match in Zenminds Live for the broadcast graphics"
      data-testid={`broadcast-${matchId}`}
    >
      <Radio className="w-3.5 h-3.5" />
      Broadcast
    </a>
  );
}
